document.addEventListener('DOMContentLoaded', function() {  // Ensure form is loaded
  const contactForm = document.getElementById('ContactForm');
  if (contactForm) { // Check if the form exists on the page
    contactForm.addEventListener('submit', function(event) {
      let checkboxes = document.querySelectorAll('input[name="contact[Assunto][]"]:checked');
      let selectedSubjects = Array.from(checkboxes).map(cb => cb.value);

      let hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'contact[Assunto]';  // Correct name for Shopify
      hiddenInput.value = selectedSubjects.join(','); // Comma-separated string

      this.appendChild(hiddenInput);

      // Optional: Remove original checkboxes for cleaner data
      checkboxes.forEach(cb => cb.remove());
    });
  }
});